import {makeAutoObservable, runInAction} from "mobx";
import {NavigateFunction} from "react-router-dom";

export enum routes {
    home = '/',
    game = '/game',
    login = '/login',
    registration = '/registration'
}

type RouteValues = typeof routes[keyof typeof routes];

class NavigateStore {

    navigateFn: NavigateFunction | null = null;

    constructor() {
        makeAutoObservable(this, {
            navigate: false
        });
    }

    setNavigate(navigate: NavigateFunction) {
        runInAction(() => {
            this.navigateFn = navigate
        })
    }

    navigate(path: RouteValues) {
        if (this.navigateFn) {
            this.navigateFn(path)
        }
    }
}

export const navigateStore = new NavigateStore();